import React, { Component } from 'react';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import shortid from 'short-id';
import {
  Segment,
  Header,
  Image,
  Dropdown,
  Accordion,
  Checkbox
} from 'semantic-ui-react';
// import _ from 'lodash';
import moment from 'moment';

import Images from '../../assets/Images';

import * as AppActions from '../../actions';
import './PresentationDetail.css';
import domains from '../../containers/Domains';
import PreviewAccordionItem from './AdImportComponents/PreviewAccordionItem';
import { makeGetWithoutTokenParam } from '../../services/ServiceManager';

const Center = styled.div`
  height: 100%;
  margin-top: 140px;
`;
const IframeContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
const IframeView = styled.iframe`
  width: ${(props) => `${props.width}px !important`};
  height: ${(props) => `${props.height}px !important`};
`;

class PresentationDetail extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired
  };

  state = {
    compareMobDesk: false,
    expandAll: true,
    isIE: false || !!document.documentMode,
    expiredAt: '',
    activeIndex: null,
    linkExpired: false,
    networkError: false,
    loading: false,
    previews: [],
    minWidth: 1,
    minHeight: 400,
    showTutorialStep: '',
    presentation: {
      id: null,
      data: null,
      url: null
    }
  };

  handleAccordionClick = (index, campaignKey) => {
    this.nextStep(2);
    const { accordionIndex } = this.state;
    if (accordionIndex[campaignKey] === index) {
      accordionIndex[campaignKey] = -1;
    } else {
      accordionIndex[campaignKey] = index;
    }

    this.setState({ accordionIndex });
  };

  handleExpandAll = () => {
    this.nextStep(4);
    this.setState({ expandAll: !this.state.expandAll });
  };

  componentDidMount() {
    this.init();
  }

  init = async () => {
    // const tokenName = 'sysuser_read_only';
    // const host =
    //   window.location.hostname !== 'localhost' ? domains[window.location.hostname] : domains['lambda-functions'];
    // const url = `${host}token/${tokenName}`;

    // const query = _.template(url);
    // const result = await fetch(query()).then(async (data) => {
    //   const resultQuery = await data.json();
    //   this.setState({ token: resultQuery.token.token });
    //   await this.props.actions.fetchPresentationImport(`${host}service/ad/import?url=${this.props.match.params.url}`);
    // });

    const resultToken = await makeGetWithoutTokenParam(
      'token/public',
      null,
      null
    );
    if (resultToken.statusCode === 200) {
      await this.setState({ token: resultToken.token });
      const host =
        window.location.hostname !== 'localhost'
          ? domains[window.location.hostname]
          : domains['lambda-functions'];
      await this.props.actions.fetchPresentationImport(
        `${host}service/ad/import?url=${this.props.match.params.url}`
      );
    }
  };

  componentWillReceiveProps(nextProps) {
    const { presentationData } = nextProps.adImport;
    if (presentationData && presentationData.data) {
      if (presentationData.statusCode === 200) {
        const expireDate = moment(presentationData.data.expired_at);
        const today = moment(new Date());
        const isExpired = today.isAfter(expireDate);
        if (!isExpired) {
          const cachedQuery = JSON.parse(presentationData.data.cachedquery);
          const ads = cachedQuery.ads_ids;

          this.setState({
            previews: ads,
            expandAll: true,
            presentation: { ...presentationData.data },
            linkExpired: false,
            networkError: false,
            expiredAt: presentationData.data.expired_at
          });
        } else {
          this.setExpiredStatus();
        }
      } else {
        this.setNetworkStatus();
      }
    } else {
      this.setExpiredStatus();
    }
  }

  setExpiredStatus = () => {
    this.setState({
      previews: [],
      expandAll: false,
      linkExpired: true
    });
  };

  setNetworkStatus = () => {
    this.setState({
      previews: [],
      expandAll: false,
      networkError: true
    });
  };

  handleExpandAll = () => {
    this.setState({ expandAll: !this.state.expandAll });
  };

  handleAccordionClick = (index) => {
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  renderIframe = (url, width, height) => {
    return (
      <IframeContainer className="iframe-import-ad">
        <IframeView src={url} scrolling="no" width={width} height={height} />
      </IframeContainer>
    );
  };

  renderAccordion = () => {
    return (
      <Center>
        <div className="tab container-no-border">
          <Accordion fluid styled>
            {this.state.previews.map((preview, index) => {
              const _preview = { ...preview, title: preview.name };
              return (
                <PreviewAccordionItem
                  key={shortid.generate()}
                  adPreview={_preview}
                  activeIndex={this.state.activeIndex}
                  index={index}
                  selectedAds={[]}
                  showCheckboxes={false}
                  handleAccordionClick={this.handleAccordionClick}
                  handleSelectAd={() => null}
                  renderIframe={this.renderIframe}
                  expandAll={this.state.expandAll}
                />
              );
            })}
          </Accordion>
        </div>
      </Center>
    );
  };

  renderPatentPendingLogo = () => {
    return (
      <div className="logo-patent-pending-share-link">
        <Image
          src={Images.patentPending}
          className="App-patent-pending"
          alt="patentPending"
          verticalAlign="small"
          size="medium"
        />
      </div>
    );
  };

  renderPresentationStateTitle = () => {
    if (this.state.presentation && this.state.presentation.data) {
      const preData = JSON.parse(this.state.presentation.data);
      const presentationName = preData.title
        .replace(this.state.selectedMonth, '')
        .replace('CUSTOM -', '');
      return `${presentationName}`;
    }
    return '';
  };

  renderPresentation = () => {
    const { loading, error } = this.props.adImport;

    if (error) {
      return <p>{error.message}</p>;
    }
    if (loading) {
      return <p>Loading ...</p>;
    } else if (this.state.linkExpired || this.state.networkError) {
      return (
        <div>
          <div className="text-expires">
            {this.state.expiredAt && this.state.expiredAt !== '' ? (
              <ul className="text-expires-list">
                <li>Share link expires on:</li>
                <li>{moment(this.state.expiredAt, 'YYYY-MM-DD')}</li>
              </ul>
            ) : null}
          </div>
          {this.state.linkExpired ? (
            <div className="div-link-expired">
              <p>
                <b>LINK EXPIRED</b>
              </p>
              <p>
                This link has expired and its ad previews are no longer
                viewable.
              </p>
              <p>
                Please contact your account manager to receive an updated link.
              </p>
            </div>
          ) : (
            <div className="div-link-expired">
              <p>
                <b>SERVICE UNAVAILABLE</b>
              </p>
              <p>Service is temporarily unavailable, please try again later.</p>
            </div>
          )}
          <div className="logo-patent-pending-expired">
            {this.renderPatentPendingLogo()}
          </div>
        </div>
      );
    }
    return (
      <div>
        <div className="presentation-account-expiration-container">
          <div className="text-expires presentation-expires icon-list">
            <ul className="text-expires-list">
              <li>
                <div className="logo-patent-pending-tab">
                  {this.renderPatentPendingLogo()}
                </div>
              </li>
              <li className="list-divider expand-all-container">
                {this.state.showTutorialStep === 4 ? (
                  <div
                    className="tooltip"
                    role="button"
                    tabIndex={0}
                    onClick={() => this.nextStep(4)}
                  >
                    <div className="tooltiptext expand-all-step">
                      Click &quot;Expand All&quot; to view all ads
                      <div
                        onClick={this.finishTutorial}
                        role="button"
                        tabIndex={0}
                        className="tooltip-expand-all-step close-tooltip"
                      >
                        <span className="close-content">X</span>
                      </div>
                    </div>
                  </div>
                ) : null}
                <strong>Expand all</strong>{' '}
                <Checkbox
                  toggle
                  onChange={this.handleExpandAll}
                  checked={this.state.expandAll}
                />
              </li>
            </ul>
          </div>
        </div>
        <Header as="h1" className="custom-header">
          <Image
            src={Images.alexiaGoldLogoSm}
            alt="logo"
            className="floated left inline tiny"
          />
          <span className="floated left inline">
            {this.renderPresentationStateTitle()}
            {!this.state.isIE ? (
              <span
                className="tutorial-circle"
                role="button"
                tabIndex={0}
                onClick={this.startTutorial}
              >
                ?
              </span>
            ) : null}
          </span>
          <p className="expires-text-container">
            <label htmlFor="expires-text-container">
              Share link expires{' '}
              {moment(this.state.expiredAt, 'YYYY-MM-DD').fromNow()}
            </label>
          </p>
        </Header>
        {this.state.isIE ? (
          <p className="emptyAdsMessage">
            Alexia works best on Chrome or Firefox. You may encounter issues
            while using Internet Explorer
          </p>
        ) : null}
        {/* {this.state.showAccountsList ? (
            <div className="presentation-account-container">
              <p>
                <Dropdown
                  placeholder="Ad Accounts"
                  search
                  selection
                  options={this.state.accountOptions}
                  onChange={this.onAccountSelect}
                  className="accounts-dropwdon"
                />
              </p>
            </div>
          ) : null}
          {this.state.loadingAds ? <p>Loading Ads...</p> : null} */}

        <div className="container">
          <div className={'campaigns-tabs-container'}>
            {this.state.showTutorialStep === 2 ? (
              <div className="tooltip">
                <div
                  role="button"
                  tabIndex={0}
                  onClick={() => this.nextStep(2, true)}
                  className="drawers-step tooltiptext"
                >
                  Click drawers to view individual ads
                  <div
                    role="button"
                    tabIndex={0}
                    onClick={this.finishTutorial}
                    className="tooltip-drawers-step close-tooltip"
                  >
                    <span className="close-content">X</span>
                  </div>
                </div>
              </div>
            ) : null}
            {this.renderAccordion()}
          </div>
        </div>
      </div>
    );
  };

  /**
   * Rendering functions for mobile screen, ALEXIA-1095
   */

  renderPresentationOnMobile = () => {
    const loading = this.props.presentationData
      ? this.props.presentationData.loading
      : true;
    const error = this.props.presentationData
      ? this.props.presentationData.error
      : false;

    if (error) {
      return <p>{error.message}</p>;
    }

    if (loading) {
      return <p>Loading ...</p>;
    } else if (this.state.linkExpired || this.state.networkError) {
      return (
        <div>
          <div className="text-expires">
            {this.state.expiredAt && this.state.expiredAt !== '' ? (
              <ul className="text-expires-list">
                <li>Share link expires on:</li>
                <li>{moment(this.state.expiredAt, 'YYYY-MM-DD')}</li>
              </ul>
            ) : null}
          </div>
          {this.state.linkExpired ? (
            <div className="div-link-expired">
              <p>
                <b>LINK EXPIRED</b>
              </p>
              <p>
                This link has expired and its ad previews are no longer
                viewable.
              </p>
              <p>
                Please contact your account manager to receive an updated link.
              </p>
            </div>
          ) : (
            <div className="div-link-expired">
              <p>
                <b>SERVICE UNAVAILABLE</b>
              </p>
              <p>Service is temporarily unavailable, please try again later.</p>
            </div>
          )}
          <div className="logo-patent-pending-expired">
            {this.renderPatentPendingLogo()}
          </div>
        </div>
      );
    }
    return (
      <div>
        <div className="presentation-account-expiration-container">
          <div className="text-expires presentation-expires icon-list">
            <ul className="text-expires-list">
              <li>
                <div className="logo-patent-pending-tab">
                  {this.renderPatentPendingLogo()}
                </div>
              </li>
            </ul>
          </div>
        </div>
        <Header as="h1" className="custom-header">
          <Image
            src={Images.alexiaGoldLogoSm}
            alt="logo"
            className="floated left inline tiny"
          />
          <span className="floated left inline">
            {this.renderPresentationStateTitle()}
          </span>
          <p className="expires-text-container">
            <label htmlFor="expires-text-container">
              Share link expires{' '}
              {moment(this.state.expiredAt, 'YYYY-MM-DD').fromNow()}
            </label>
          </p>
        </Header>
        {this.state.isIE ? (
          <p className="emptyAdsMessage">
            Alexia works best on Chrome or Firefox. You may encounter issues
            while using Internet Explorer
          </p>
        ) : null}
        {this.state.showAccountsList ? (
          <div className="presentation-account-container">
            <p>
              <Dropdown
                placeholder="Ad Accounts"
                search
                selection
                options={this.state.accountOptions}
                onChange={this.onAccountSelect}
                className="accounts-dropwdon"
              />
            </p>
          </div>
        ) : null}
        {this.state.loadingAds ? <p>Loading Ads...</p> : null}

        {this.state.dataLoaded ? (
          <div className="container">
            <div
              className={
                this.state.showAccountsList
                  ? 'campaigns-tabs-container-mult'
                  : 'campaigns-tabs-container'
              }
            >
              {this.state.showTutorialStep === 2 ? (
                <div className="tooltip">
                  <div
                    role="button"
                    tabIndex={0}
                    onClick={() => this.nextStep(2, true)}
                    className="drawers-step tooltiptext"
                  >
                    Click drawers to view individual ads
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={this.finishTutorial}
                      className="tooltip-drawers-step close-tooltip"
                    >
                      <span className="close-content">X</span>
                    </div>
                  </div>
                </div>
              ) : null}
              {this.renderAccordion()}
            </div>
          </div>
        ) : null}

        {/* { this.state.dataLoaded && this.state.mobileState.selectedPreview != null ? 
            <SwipeCloseModel 
              reset={ this.state.mobileState.selectedPreview != null}
              adTitle={ this.state.mobileState.selectedAdName }
              content={this.renderAdDetail(this.state.mobileState.selectedPreview)} /> : null } */}
      </div>
    );
  };

  /* ALEXIA-1095
    Media query breakpoints
      iPhone X: 375px
      iPhone 6/7/8 Plus: 424px
      iPad: 768px
      iPad Pro: 1024px
  */
  render() {
    const screenSize = window.innerWidth;
    const loadedOnMobileScreen = screenSize <= 414;

    if (loadedOnMobileScreen) {
      return (
        <div className="container" style={{ width: '100%' }}>
          <div className={'generic-content custom-generic-content'}>
            <Segment className="share-links-container" basic>
              {this.renderPresentationOnMobile()}
            </Segment>
          </div>
        </div>
      );
    }
    return (
      <div className="container" style={{ width: '100%' }}>
        <div className={'generic-content custom-generic-content'}>
          <Segment className="share-links-container" basic>
            {this.renderPresentation()}
          </Segment>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    adImport: state.adImport
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default withCookies(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PresentationDetail)
);



// WEBPACK FOOTER //
// ./src/screens/AdImport/PresentationDetail.js